import { render, staticRenderFns } from "./BottomNav.vue?vue&type=template&id=243eadfa&scoped=true&"
import script from "./BottomNav.vue?vue&type=script&lang=ts&"
export * from "./BottomNav.vue?vue&type=script&lang=ts&"
import style0 from "./BottomNav.vue?vue&type=style&index=0&id=243eadfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243eadfa",
  null
  
)

component.options.__file = "BottomNav.vue"
export default component.exports